import { render, staticRenderFns } from "./GameSelect.vue?vue&type=template&id=876f6978&scoped=true"
import script from "./GameSelect.vue?vue&type=script&lang=js"
export * from "./GameSelect.vue?vue&type=script&lang=js"
import style0 from "./GameSelect.vue?vue&type=style&index=0&id=876f6978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876f6978",
  null
  
)

export default component.exports